import React from "react";
import { ChartNew } from "../../../../../components";

const PieChartList = () => {
  return (
    <div className="grid grid-cols-2 gap-5 bg-gray-100 p-2">
      <div className=" flex h-[400px] bg-white rounded-lg p-3">
        {/* <ChartNew type="piechart" noTitle value={90} /> */}
        <ChartNew
          type="piechart"
          noTitle
          rawData={[
            { name: "Completed", value: 20, color: "primary", colorDepth: 500 },
            {
              name: "In Progress",
              value: 40,
              color: "success",
              colorDepth: 500,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default PieChartList;
